import { createSystem, defineConfig, defaultConfig } from '@chakra-ui/react';

const config = defineConfig({
  theme: {
    tokens: {
      colors: {
        brand: {
          50: { value: '#EFF6FF' },
          100: { value: '#DBEAFE' },
          200: { value: '#BFDBFE' },
          300: { value: '#93C5FD' },
          400: { value: '#60A5FA' },
          500: { value: '#2563EB' },
          600: { value: '#1D4ED8' },
          700: { value: '#1E40AF' },
          800: { value: '#1E3A8A' },
          900: { value: '#1E293B' },
        },
      },
      fonts: {
        heading: { value: 'Inter, system-ui, sans-serif' },
        body: { value: 'Inter, system-ui, sans-serif' },
      },
    },
  },
});

export const theme = createSystem(defaultConfig, config);